import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from 'react-bootstrap';
import useOwnerNotesModal from 'components/propertyCard/ownerNotesModal/useOwnerNotesModal';
import {
  ActionWrapper,
  Container,
  PropertyInfoWrapper,
} from './PropertyCard.styles';

interface PropertyCardProps {
  name: string;
  address: string;
  aditionalInformation: string;
  imageUrl: string;
  rentalUrl: string;
  ownerNotes?: string;
}

const PropertyCard: React.FC<PropertyCardProps> = ({
  name,
  address,
  imageUrl,
  aditionalInformation,
  rentalUrl,
  ownerNotes,
}) => {
  const { t } = useTranslation();
  const { openOwnerNotesModal } = useOwnerNotesModal();

  // Check for empty html tags
  const hasNotes = !!new DOMParser().parseFromString(
    ownerNotes ?? '',
    'text/html',
  ).documentElement.textContent;

  const handleOpenNotesModal = () => {
    if (!ownerNotes) return;

    openOwnerNotesModal({ notes: ownerNotes });
  };

  return (
    <Container>
      <PropertyInfoWrapper>
        <img src={imageUrl} alt={`${name} thumbnail`} />

        <div>
          <h3>{name}</h3>
          <p>{address}</p>
          <p>{aditionalInformation}</p>
        </div>
      </PropertyInfoWrapper>

      <ActionWrapper>
        {!!rentalUrl && (
          <a
            href={rentalUrl}
            target="_blank"
            data-testid="property-card-rental-url-button"
            rel="noreferrer"
          >
            {t('pageProperties.viewListing')}
          </a>
        )}

        {hasNotes && (
          <Button
            bsStyle="link"
            onClick={handleOpenNotesModal}
            data-testid="property-card-owner-notes-button"
          >
            {t('pageProperties.viewAgencyNotes')}
          </Button>
        )}
      </ActionWrapper>
    </Container>
  );
};

PropertyCard.defaultProps = {
  ownerNotes: undefined,
};

export default PropertyCard;
